module.exports = __webpack_public_path__ + "img/zhuyifuwu_image_ylfw_zlfw.8a2a9c3a.png";